/* ═══════════════════════════════════════════════════════════════
   BATCH 7: Offline Cache
   Cache API responses for offline access
   Required for Apple App Store - app must provide value beyond website
   ═══════════════════════════════════════════════════════════════ */

import storage from './storage';

const CACHE_KEYS = {
  DEBTS: 'offline_cache_debts',
  USER: 'offline_cache_user',
  ANALYSIS: 'offline_cache_analysis',
  TIMESTAMP: 'offline_cache_timestamp',
};

const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours

class OfflineCache {
  async set(key, data) {
    try {
      await storage.set(key, data);
      await storage.set(CACHE_KEYS.TIMESTAMP, Date.now());
    } catch (err) {
      console.error('Error setting cache:', err);
    }
  }

  async get(key) {
    try {
      const timestamp = await storage.get(CACHE_KEYS.TIMESTAMP);
      if (!timestamp || Date.now() - timestamp > CACHE_DURATION) {
        return null; // Cache expired
      }
      return await storage.get(key);
    } catch (err) {
      console.error('Error getting cache:', err);
      return null;
    }
  }

  async clear() {
    try {
      await storage.remove(CACHE_KEYS.DEBTS);
      await storage.remove(CACHE_KEYS.USER);
      await storage.remove(CACHE_KEYS.ANALYSIS);
      await storage.remove(CACHE_KEYS.TIMESTAMP);
    } catch (err) {
      console.error('Error clearing cache:', err);
    }
  }

  async setDebts(debts) {
    await this.set(CACHE_KEYS.DEBTS, debts);
  }

  async getDebts() {
    return await this.get(CACHE_KEYS.DEBTS);
  }

  async setUser(user) {
    await this.set(CACHE_KEYS.USER, user);
  }

  async getUser() {
    return await this.get(CACHE_KEYS.USER);
  }

  async setAnalysis(analysis) {
    await this.set(CACHE_KEYS.ANALYSIS, analysis);
  }

  async getAnalysis() {
    return await this.get(CACHE_KEYS.ANALYSIS);
  }

  async isStale() {
    const timestamp = await storage.get(CACHE_KEYS.TIMESTAMP);
    return !timestamp || Date.now() - timestamp > CACHE_DURATION;
  }
}

export default new OfflineCache();
